export default class MasterDetailsReport {
  constructor(id) {
    this.id = id;
  }
}
